import RolePrivilegeService from '../../services/AdminRolePriviliege.service'
import BrandingService from '../../services/branding.service'
import RoleService from '../../services/adminRole.service'
import UserService from '../../services/user.service'

const AccessToken = localStorage.getItem('accessToken')

export const auth = {
  namespaced: true,
  state: {
    loggedIn: !!AccessToken,
    UserData: null,
    Permissions: [],
    PrivilegeIds: [],
    brandingInformation: null,
    availableServices: []
  },
  getters: {
    getSessionUser: state => {
      if (state.UserData) {
        return state.UserData
      }
      // Fallback to localStorage if state is null
      const userJson = localStorage.getItem('ai_platform_user')
      if (userJson) {
        try {
          return JSON.parse(userJson)
        } catch (e) {
          console.error('Failed to parse ai_platform_user from localStorage:', e)
          return null
        }
      }
      return null
    }
  },
  actions: {
    login ({ commit }, userObj) {
      commit('loginSuccess', userObj)
    },
    logout ({ commit }) {
      commit('logout')
    },
    fetchBrandingInformation ({ commit }) {
      return BrandingService.getBrandingInfo().then(
        response => {
          if (response.data.Status) {
            commit('setBrandingInformation', response.data.Object)
            commit('setAvailableServices', response.data.Object.pageContents)
          } else {
            commit('setBrandingInformation', null)
            commit('setAvailableServices', [])
          }
          return Promise.resolve(response.data)
        },
        error => {
          commit('setBrandingInformation', null)
          commit('setAvailableServices', [])
          return Promise.reject(error)
        }
      )
    },
    fetchAndSetPermissions ({ commit }) {
      if (this.state.auth.Permissions.length === 0) {
        return RolePrivilegeService.getCurrentUsersRolePriviliges()
          .then(
            response => {
              if (response.data.Status) {
                commit('setPermissions', response.data.Object.adminPermissions.permissionList)
                return Promise.resolve(response.data.Object.adminPermissions.permissionList)
              } else {
                commit('setPermissions', [])
                return Promise.resolve(response.data)
              }
            },
            error => {
              commit('setPermissions', [])
              return Promise.reject(error)
            }
          )
      } else {
        return Promise.resolve(this.state.auth.Permissions)
      }
    },
    fetchAndSetRolePrivilegeIds ({ commit }) {
      return RoleService.getAdminRolePrivilegeIdsByAdminRoleId(this.state.auth.UserData.AdminRoleId)
        .then(
          response => {
            if (response && response.data.Status) {
              commit('setPrivilegeIds', response.data.Object.PrivilegeIds)
            } else {
              commit('setPrivilegeIds', [])
            }
            return Promise.resolve(response.data)
          },
          error => {
            commit('setPrivilegeIds', [])
            return Promise.reject(error)
          }
        )
    },
    fetchCurrentUserInformation ({ commit }) {
      return UserService.getCurrentUserData().then(
        response => {
          if (response.data.Status) {
            commit('setUserData', response.data.Object.user)
          } else {
            commit('logout')
          }
          return Promise.resolve(response.data)
        },
        error => {
          commit('logout')
          return Promise.resolve(error)
        }
      )
    },
    refreshSessionUser ({ commit }, User) {
      commit('refreshSessionUser', User)
    },
    refreshAccessToken ({ commit }, AccessToken) {
      commit('refreshAccessToken', AccessToken)
    }
  },
  mutations: {
    loginSuccess (state, userObj) {
      state.loggedIn = true
      state.UserData = userObj.userData
      localStorage.setItem('accessToken', userObj.accessToken)
    },
    setPermissions (state, Permissions) {
      state.Permissions = Permissions
    },
    setPrivilegeIds (state, PrivilegeIds) {
      state.PrivilegeIds = PrivilegeIds
    },
    setBrandingInformation (state, brandingInformation) {
      state.brandingInformation = brandingInformation
    },
    setAvailableServices (state, pageContents) {
      var availableServices = []
      if (pageContents) {
        if (pageContents.ClassService === '1') {
          availableServices.push('Classes')
        }
        if (pageContents.MembershipService === '1') {
          availableServices.push('Library Membership')
        }
        if (pageContents.ProductService === '1') {
          availableServices.push('Products')
        }
        if (pageContents.RentalService === '1') {
          availableServices.push('Breast Pump rentals')
        }
        if (pageContents.SupportGroupService === '1') {
          availableServices.push('Support Group')
        }
        if (pageContents.TourService === '1') {
          availableServices.push('Birth Center Tours')
        }
        if (pageContents.WebinarService === '1') {
          availableServices.push('Webinar')
        }
      }
      state.availableServices = availableServices
    },
    setUserData (state, userData) {
      state.UserData = userData
      state.loggedIn = true
    },
    logout (state) {
      state.UserData = null
      state.loggedIn = false
      state.Permissions = []
      localStorage.removeItem('accessToken')
    },
    refreshSessionUser (state, User) {
      if (state.UserData) {
        state.UserData = User
        state.loggedIn = true
      }
    },
    refreshAccessToken (state, AccessToken) {
      localStorage.setItem('accessToken', AccessToken)
      state.loggedIn = true
    }
  }
}
